var waitFor = require('../utils/waitFor');

waitFor('.js-accordion', function() {

  $('.js-accordion dt').on('click', function(e){
    var $el = $(e.currentTarget);

    if($el.hasClass('is-open'))
      $el.removeClass('is-open').addClass('is-closed');
    else
      $el.removeClass('is-closed').addClass('is-open');
  })

  $('.js-accordion-expand-all').on('click', function(e){
    $('.js-accordion dt').removeClass('is-closed').addClass('is-open');
  })

  $('.js-accordion-collapse-all').on('click', function(e){
    $('.js-accordion dt').removeClass('is-open').addClass('is-closed');
  })

});
